import "../../css/CommonDesign.css";
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Tabs, Tab, Typography, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, ToggleButton, ToggleButtonGroup, FormControl, FormHelperText, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { ProductContext } from "../D001SearchTop";
import { MsgContext } from "../../../App";
import axios from "axios";
import { API } from "../constantsFront";
import $ from "jquery";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function ProductDialog() {
  const { autocompleteProduct, setAutocompleteProduct } = useContext(ProductContext);

  // 品目リスト
  const [categoryProductList, setCategoryProductList] = useState("");
  const [jaProductList, setJaProductList] = useState("");
  // 品目カテゴリリスト
  const [categoryList, setCategoryList] = useState("");

  const [categoryProductTabs, setCategoryProductTabs] = useState(""); //ダイアログタブ
  const [jaPesticideTabs, setJaProductTabs] = useState(""); //ダイアログタブ（和）
  const [categoryProductDialogContent, setCategoryProductDialogContent] = useState(""); //ダイアログコンテキスト（カテゴリ別）
  const [jaProductDialogContent, setJaProductDialogContent] = useState(""); //ダイアログコンテキスト（五十音順）
  const [isCategory, setIsCategory] = useState(false);
  const [isJa, setIsJa] = useState(false);

  // ダイアログ関連
  const [categoryValue, setCategoryValue] = useState(0);
  const [jaValue, setJaValue] = useState(0);
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [dialogItem, setDialogItem] = useState("category"); // ダイアログ内の選択項目

  const [errorProduct, setErrorProduct] = useState(""); // 品目エラー

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  let body = { authKey: API.API_KEY };

  function dialogData(categoryProductList, jaProductList, kubunList, jaIniList) {
    try {
      let categoryProductTabs = [];
      let jaProductTabs = [];
      let categoryProductDialogContent = [];
      let jaProductDialogContent = [];

      // ダイアログ用
      let index = 0;

      // ダイアログ内の作成（カテゴリ別）
      for (let i in kubunList) {
        let productKubun = kubunList[i].category_name;

        categoryProductTabs.push(<Tab label={productKubun} {...a11yProps(i)} />);

        let categoryList = [];

        for (let j in categoryProductList) {
          let selectProductName2 = categoryProductList[j].product_name;
          let productKubun2 = categoryProductList[j].category_name;
          if (productKubun == productKubun2) {
            let radio = <input type="radio" name="categoryProduct" value={j} />;
            categoryList.push(<li><label>{radio}{selectProductName2}</label></li>);
          }
        }

        let all = "all" + index;
        let br = <br />;
        if (index == 0) {
          br = "";
        }

        categoryProductDialogContent.push(<>{br}
          <li><label name={all} id={all}>{productKubun}</label></li><hr />
          {/* <Stack spacing={4} direction="row"> */}
          {/* <Stack spacing={0}> */}
          <ul>{categoryList}</ul>
          {/* </Stack> */}
          {/* </Stack> */}
        </>);
        index += 1;
      }

      // ダイアログ内の作成（五十音順）
      for (let i in jaIniList) {
        let jaInitials = jaIniList[i].ja_initials;

        jaProductTabs.push(<Tab label={jaInitials} {...a11yProps(kubunList.length + Number(i))} />);

        let categoryList = [];

        for (let j in jaProductList) {
          let selectProductName2 = jaProductList[j].product_name;
          let jaInitials2 = jaProductList[j].ja_initials;
          if (jaInitials == jaInitials2) {
            let radio = <input type="radio" name="jaProduct" value={j} />;
            categoryList.push(<li><label>{radio}{selectProductName2}</label></li>);
          }
        }

        let all = "all" + index;
        let br = <br />;
        if (index == kubunList.length) {
          br = "";
        }

        jaProductDialogContent.push(<>{br}
          <li><label name={all} id={all}>{jaInitials}</label></li><hr />
          <ul>{categoryList}</ul>
        </>);
        index += 1;
      }

      setDialogItem("category");
      setIsCategory(true);
      setIsJa(false);
      setCategoryProductTabs(categoryProductTabs);
      setJaProductTabs(jaProductTabs);
      setCategoryProductDialogContent(categoryProductDialogContent);
      setJaProductDialogContent(jaProductDialogContent);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // ダイアログ内の項目選択
  const itemChange = (event, newitem) => {
    if (newitem) {
      setDialogItem(newitem);
      setCategoryValue(0);
      setJaValue(0);

      if (newitem == "category") {
        setIsCategory(true);
      } else {
        setIsCategory(false);
      }
      if (newitem == "ja") {
        setIsJa(true);
      } else {
        setIsJa(false);
      }
      $("#dialog-content").scrollTop(0);
    }
  };

  // ダイアログ処理
  function categoryDialigChange(event, newValue) {
    setCategoryValue(newValue);
    //移動したい内容の位置を取得
    let top = $("#all" + newValue).offset().top;
    let all0Top = $("#all0").offset().top;
    //スクロールを移動する
    $("#dialog-content").scrollTop(top - all0Top + 10);
  };
  function jaDialigChange(event, newValue) {
    setJaValue(newValue);
    //移動したい内容の位置を取得
    let top = $("#all" + (categoryList.length + newValue)).offset().top;
    let all0Top = $("#all" + categoryList.length).offset().top;
    //スクロールを移動する
    $("#dialog-content").scrollTop(top - all0Top + 10);
  };

  async function handleClickOpen() {
    try {
      // 品目リスト（カテゴリ別）
      body.item = "category";
      let res = await axios.post("/m_product_kubun/select", body);
      setCategoryProductList(res.data.dataList);
      const categoryProductList = res.data.dataList;

      // 品目リスト（五十音順）
      body.item = "ja";
      res = await axios.post("/m_product_kubun/select", body);
      setJaProductList(res.data.dataList);
      const jaProductList = res.data.dataList;

      // カテゴリリスト
      res = await axios.post("/m_product_kubun/select/kubunList", body);
      setCategoryList(res.data.dataList)
      const kubunList = res.data.dataList;

      // 和名頭文字リスト
      res = await axios.post("/m_rac_ja_initials/select", body);
      const jaIniList = res.data.dataList;

      dialogData(categoryProductList, jaProductList, kubunList, jaIniList);
      setOpen(true);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // キャンセルボタン
  function cancelButton() {
    setOpen(false);
    setCategoryValue(0);
    setJaValue(0);
    setErrorProduct("");
  };

  // 決定ボタン
  function decisionButton() {
    try {
      let productChecked = [];
      let productCheckList;
      // let productCode;
      let productName;
      if (dialogItem == "category") {
        productCheckList = document.getElementsByName("categoryProduct");
      } else if (dialogItem == "ja") {
        productCheckList = document.getElementsByName("jaProduct");
      }
      for (let i = 0; i < productCheckList.length; i++) {
        if (productCheckList[i].checked) {
          if (dialogItem == "category") {
            // productCode = categoryProductList[productCheckList[i].value].product_code;
            productName = categoryProductList[productCheckList[i].value].product_name;
          } else if (dialogItem == "ja") {
            // productCode = jaProductList[productCheckList[i].value].product_code;
            productName = jaProductList[productCheckList[i].value].product_name;
          }
          productChecked.push({
            product_code: productName,
            product_name: productName
          });
        }
      }
      if (!productName) {
        return setErrorProduct("※品目を選択してください");
      }
      setAutocompleteProduct(productChecked);
      setOpen(false);
      setCategoryValue(0);
      setJaValue(0);
      setErrorProduct("");
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        Height="md"
        fullScreen={fullScreen}
        open={open}
        onClose={cancelButton}
        aria-labelledby="responsive-dialog-title"
      >

        {/* <DialogTitle style={{ backgroundColor: "red", color: "white", textAlign: "center" }} onClose={cancelButton}>
          品目名一覧
        </DialogTitle> */}
        <BootstrapDialogTitle id="customized-dialog-title" style={{ backgroundColor: "#1B335E", color: "#fff", textAlign: "center" }} onClose={cancelButton}>
          品目名一覧
        </BootstrapDialogTitle>
        <ToggleButtonGroup
          color="primary"
          value={dialogItem}
          exclusive
          onChange={itemChange}
          aria-label="Platform"
        >
          <ToggleButton value="category" style={{ width: "50%" }}>カテゴリ別</ToggleButton>
          <ToggleButton value="ja" style={{ width: "50%" }}>五十音順</ToggleButton>
        </ToggleButtonGroup>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          {isCategory ?
            <Tabs
              value={categoryValue}
              onChange={categoryDialigChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#B00002',
                }
              }}
            >
              {categoryProductTabs}
            </Tabs>
            : null}
          {isJa ?
            <Tabs
              value={jaValue}
              onChange={jaDialigChange}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              TabIndicatorProps={{
                style: {
                  backgroundColor: '#B00002',
                }
              }}
            >
              {jaPesticideTabs}
            </Tabs>
            : null}
        </Box>
        <DialogContent id="dialog-content">
          <TabPanel value={0} index={0}>
            <div hidden={!isCategory}>{categoryProductDialogContent}</div>
            <div hidden={!isJa}>{jaProductDialogContent}</div>
          </TabPanel>
        </DialogContent>
        {/* <DialogActions>
          <Button onClick={cancelButton}>
            キャンセル
          </Button>
          <Button onClick={decisionButton}>
            決定
          </Button>
        </DialogActions> */}
        <div style={{ textAlign: "center" }}>
          <FormControl error={errorProduct}>
            <FormHelperText>{errorProduct}</FormHelperText>
          </FormControl>

          <div style={{
            display: "flex"
            , justifyContent: "center"
            , position: "relative"
            , flexWrap: "wrap"
            // , marginTop: "40px"
            , marginBottom: "40px"
          }}>

            <input type="button" style={{ width: "150px", margin: "0 10px" }} value="キャンセル" class="buttonDefault modalClose graylBtn" onClick={cancelButton} />
            <input type="button" style={{ width: "150px", margin: "0 10px" }} value="決定" class="buttonDefault" onClick={decisionButton} />
          </div>
        </div>
      </Dialog>
      {/* </div> */}
      {/* <Button className="buttonDefault" onClick={handleClickOpen}>一覧から選択</Button> */}
      <input type="button" class="buttonDefault" onClick={handleClickOpen} value="一覧から選択" />
    </>
  );
}

export default ProductDialog;